import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Authorization';
const ENDPOINT = `/authorizations/`;

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}